import { Space } from "antd";
import React, {Children, isValidElement, ReactElement} from "react";
import {CustomButton} from "./buttons";


type ContentBarProps = {
    children: ReactElement<typeof CustomButton> | ReactElement<typeof CustomButton>[]
}

export function ContentBar({children}: ContentBarProps) {
    return (
        <>
            <Space>
            {Children.map(children, (child, index) => {
                if (isValidElement(child)) {
                    return child;
                }
                return null;
            })}
            </Space>
        </>
    )
}

